import React from 'react';
import GroupLightComponent from './configs/LightGroupConfig';

const IntermediarioPagina = () => {
  return (
    <div className="intermediario-container">
      <GroupLightComponent 
        groupIds={["grupo10", "grupo11", "grupo12", "grupo13", "grupo14", "grupo15", "grupo16", "grupo17", "grupo18"]}
        /*startIndex={9}  
        endIndex={19}*/    
        pageTitle="" 
        pageId='2'
      />
    </div>
  );
};

export default IntermediarioPagina;